import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "./actions";
import RoomDragDrop from "./components/RoomDragDrop";
import {
  filterAvailableRoomsByKeyword,
  filterSelectedRoomsByKeyword,
  filterAvailableRoomsWithScheduledRoomsByKeyword
} from "./selectors";
import { getRooms } from "../../../rooms/actions";
import { translate } from "react-i18next";

class RoomPickerContainer extends Component {
  componentWillMount() {
    this.props.getRooms();
  }
  render() {
    return <RoomDragDrop {...this.props} />;
  }
}
const mapStateToProps = (state, ownProps) => ({
  available: ownProps.checked
    ? filterAvailableRoomsWithScheduledRoomsByKeyword(state)
    : filterAvailableRoomsByKeyword(state),
  selected: filterSelectedRoomsByKeyword(state),
  transfer: state.scheduleCleaning.roomPicker.transfer,
  selectedKeyword: state.scheduleCleaning.roomPicker.selectedKeyword,
  availableKeyword: state.scheduleCleaning.roomPicker.availableKeyword
});

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ ...actionCreators, getRooms }, dispatch)
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(RoomPickerContainer));



// WEBPACK FOOTER //
// ./src/cleaning/schedule/roomPicker/roomPickerContainer.js